import { ROUNDING_CUTOFF } from "./constants";
const unitToPower = {
    TB: 4,
    GB: 3,
    MB: 2,
    KB: 1,
};
const base = 1024;
/**
 * Convert bytes to human readable form.
 *
 * @param bytes Number in bytes
 * @param fractionDigits Number of fraction digits when rounding, default is 2
 * @param fixedUnit Convert to specific unit
 * @param showUnit Whether or not to show unit, default true
 */
export function humanReadableBytes(bytes, fractionDigits = 2, fixedUnit, showUnit = true) {
    const roundAndEnrichWithUnit = (value, unit) => {
        const calculatedFractionDigits = Number.isInteger(value)
            ? 0
            : fractionDigits;
        const multiplier = Math.pow(10, calculatedFractionDigits);
        // https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
        const roundedValue = Math.round(value * multiplier + Number.EPSILON) / multiplier;
        const roundedString = roundedValue.toLocaleString(undefined, {
            minimumFractionDigits: calculatedFractionDigits,
            maximumFractionDigits: calculatedFractionDigits,
        });
        return showUnit ? `${roundedString} ${unit}` : roundedString;
    };
    if (fixedUnit) {
        return roundAndEnrichWithUnit(bytes / Math.pow(base, unitToPower[fixedUnit]), fixedUnit);
    }
    if (bytes >= Math.pow(base, 4))
        return roundAndEnrichWithUnit(bytes / Math.pow(base, 4), "TB");
    else if (bytes >= Math.pow(base, 3))
        return roundAndEnrichWithUnit(bytes / Math.pow(base, 3), "GB");
    else if (bytes >= Math.pow(base, 2))
        return roundAndEnrichWithUnit(bytes / Math.pow(base, 2), "MB");
    else
        return roundAndEnrichWithUnit(bytes / base, "KB");
}
export const convertToReadable = (bytes) => bytes && bytes >= ROUNDING_CUTOFF
    ? humanReadableBytes(bytes, 2, "GB")
    : "0 GB";
export const percentToGB = (percent, bytes) => (percent * Math.pow(base, 3) * bytes) / 100;
export const convertBytesToUnit = (bytes, unit) => {
    return bytes / Math.pow(base, unitToPower[unit]);
};
export const convertUnitToBytes = (value, unit) => {
    return value * Math.pow(base, unitToPower[unit]);
};
export const bytesToGB = (bytes) => convertBytesToUnit(bytes, "GB");
export const GBToBytes = (value) => convertUnitToBytes(value, "GB");
/**
 * Calculates optimal fraction digits which can be used to display given usage in the specified unit.
 *
 * @param usedBytes Used bytes
 * @param totalBytes Total bytes
 * @param minFractionDigits Minimal fraction digits
 * @param unit Unit in which the bytes will be displayed
 * @returns
 */
export const calculateFractionDigitsForUsage = (usedBytes, totalBytes, minFractionDigits, unit) => {
    const diff = convertBytesToUnit(totalBytes, unit) - convertBytesToUnit(usedBytes, unit);
    if (diff === 0)
        return minFractionDigits;
    if (diff <= 0.009)
        return Math.max(minFractionDigits, 3);
    else if (diff <= 0.09)
        return Math.max(minFractionDigits, 2);
    else if (diff <= 0.9)
        return Math.max(minFractionDigits, 1);
    else if (diff <= 9)
        return Math.max(minFractionDigits, 0);
    return minFractionDigits;
};
//# sourceMappingURL=bytes.js.map